import GlassCard from "../GlassCard";
import "../../styles/layout.css";
import { headerContent } from "../../data/headerContent";
import { LanguageSwitcher } from "../LanguageSwitcher";
import { useNavigate } from "react-router-dom";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import whitelogo from "../../images/white-logo.png";

const HeaderPhysio = ({ lang }) => {
  const navigate = useNavigate();
  const currentLang = useCurrentLang();

  const goHome = () => {
    navigate(`/${currentLang}`);
  };

  const goRevimo = () => {
    navigate(`/${currentLang}`);
  };

  const goSignUp = () => {
    window.location.href = `https://physios.revimo.eu/signup?lang=${currentLang}`
  }
  
  const goSignIn = () => {
    window.location.href = `https://physios.revimo.eu/${currentLang}`
  }
  const goPricing = () => {
    navigate(`/${currentLang}/pricing`)
  }
  
  const goSubscriptions = () => {
    navigate(`/${currentLang}/subscriptions`)
  }
  const t = headerContent[currentLang]
  return (
    <header
      style={{
        position: "fixed",
        top: 25,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 50,
        width: "100%",
        pointerEvents: "none",
      }}
    >
      <div className="container" style={{ pointerEvents: "auto" }}>
        <GlassCard
          className="header-bar"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "14px 24px",
            borderRadius: "999px",
          }}
        >
          {/* Left – logo + name */}
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: "999px",
                backgroundColor: "var(--primary)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: 700,
                fontSize: 18,
              }}
            >
              <img src={whitelogo} alt="logo" className="logo" style={{
        width: 28,          
        height: 28,
        objectFit: "contain",
        display: "block",
      }} />
            </div>
            <span
              style={{
                fontWeight: 700,
                fontSize: 20,
                letterSpacing: 0.3,
                color: "#4c6a7a",
              }}
            >
            <button
            type="button"
            onClick={goHome}
            style={{
              fontWeight: 700,
              fontSize: 20,
              letterSpacing: 0.3,
              color: "white",
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
          >
            Revimo
          </button>
            </span>
            <div style={{ display: "flex", gap: 8 }}>
              <LanguageSwitcher />
            </div>
          </div>

          {/* Middle – nav */}
          <nav
            style={{
              display: "flex",
              gap: 32,
              fontWeight: 500,
              color: "white",
            }}
          >
            <button
              style={{
                background: "none",
                border: "none",
                padding: 0,
                color: "inherit",
              }}
              onClick={goPricing}
            >
              {t.pricing}
            </button>
            <button
              style={{
                background: "none",
                border: "none",
                padding: 0,
                color: "inherit",
              }}
              onClick={goSubscriptions}
            >
              {t.subscription}
            </button>
            <button
            onClick={goRevimo}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                color: "inherit",
              }}
            >
              {t.patients}
            </button>
          </nav>

          {/* Right – auth buttons */}
          <div
            style={{
              display: "flex",
              gap: 12,
              alignItems: "center",
            }}
          >
            <button
              style={{
                padding: "8px 18px",
                borderRadius: "999px",
                backgroundColor: "rgba(255,255,255,0.8)",
                color: "var(--primary)",
                fontWeight: 500,
              }}
              onClick={goSignIn}
            >
              {t.sign_in}
            </button>
            <button
              style={{
                padding: "8px 20px",
                borderRadius: "999px",
                backgroundColor: "var(--primary)",
                color: "white",
                fontWeight: 600,
                boxShadow: "0 10px 24px rgba(0,0,0,0.2)",
              }}
              onClick={goSignUp}
            >
              {t.sign_up}
            </button>
          </div>
        </GlassCard>
      </div>
    </header>
    
  );
};

const varTextMuted = () => "var(--text-main)";

export default HeaderPhysio;
